<template>
  <b-modal @hide="modalClose" ref="costModal" :title="$t('コスト')" size="xl">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left" width="200">{{ $t('基準売単価') }}</th>
            <td class="text-left" width="280">
              <div class="input-group">
                <input v-model.number="form.salesPrice" type="number" min="0" class="form-control input">
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{ $t('円') }}
                  </span>
                </div>
              </div>
            </td>
            <th class="table-active text-left" width="200">
              <template v-if="product.type === 'ownbrand'">
                {{ $t('基準製造原価') }}
              </template>
              <template v-else>
                {{ $t('基準仕入単価') }}
              </template>
            </th>
            <td class="text-left" width="280">
              <div class="input-group">
                <input v-model.number="form.purchasePrice" type="number" min="0" class="form-control input">
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{ $t('円') }}
                  </span>
                </div>
              </div>
              <!-- <template v-if="product.type === 'ownbrand'">
                -
              </template>
              <template v-else>
              </template> -->
            </td>
            <th class="table-active text-left" width="200">{{ $t('単位') }}</th>
            <td class="text-left" width="280">
              <input v-model="form.outputLevel" type="text" class="form-control">
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('コスト備考') }}</th>
            <td class="text-left" colspan="5">
              <input v-model="form.priceNote" type="text" class="form-control">
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    product: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(total) {
      this.form = this.mixin_deepcopy(this.product)
      if (!this.form.purchasePrice) this.form.purchasePrice = total
      this.$refs.costModal.show()
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.costModal.hide()
      this.$emit('modalClose')
    },
    async register() {
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (
          // this.product.type !== 'ownbrand' &&
          key === 'salesPrice' ||
          key === 'purchasePrice') {
          params[key] = (!this.isEmpty(this.form[key]) && this.form[key] >= 0) ? this.form[key] : -1
        } else {
          params[key] = this.form[key]
        }
      }
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/product`,
          params,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$emit('registered')
        this.$refs.costModal.hide()
        this.$toasted.success(`${this.$t('データ登録完了メッセージ')}`)
      } catch (error) {
        this.$toasted.show(`${this.$t('データ登録エラーメッセージ')}`)
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
#costModal {
  .modal-dialog {
    max-width: 125rem;
  }
}
</style>
